import React, { useCallback } from "react";
import { writeFile, utils } from "xlsx";

const useExportToExcel = (dataTable, columns) => {
  const exportToExcel = useCallback(() => {
    const data = dataTable.map((row) => {
      const rowData = {};
      columns.forEach((column) => {
        rowData[column.headerName] = row[column.field];
      });
      return rowData;
    });

    const worksheet = utils.json_to_sheet(data);

    // Set column sizes
    columns.forEach((column, index) => {
      const columnWidth = { wch: 15 }; // Custom column width, you can change this value
      worksheet["!cols"] = worksheet["!cols"] || [];
      worksheet["!cols"].push({ width: columnWidth.wch });
    });

    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Data");

    // Export the file
    writeFile(workbook, "data.xlsx");
  }, [dataTable, columns]);

  return { handleExport: exportToExcel };
};

export default useExportToExcel;
